import { RegexEnum } from '../../libs/enums';
import {
  mustBeFilled,
  mustBeLessThan,
  mustBeMoreThan,
  mustMatchFormat,
} from '../../libs/validators';

export const inputBirthcountryConfig = {
  description: 'Comme inscrit sur votre acte de naissance',
  label: 'Pays de naissance',
  name: 'birthcountry',
  validators: {
    format: [
      mustMatchFormat(
        RegexEnum.LOCATION,
        'Veuillez utiliser uniquement des caractères alpha-numériques ou de ponctuations',
      ),
      mustBeMoreThan(3),
      mustBeLessThan(256),
    ],
    submit: mustBeFilled('Veuillez renseigner votre pays de naissance'),
  },
};
